<template>
  <div id="form-cashout">
    <b-card>
      <b-row class=" mb-2">
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/accounting/cash-in">Cash In</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>

      <form v-on:submit.prevent="postCashIn">
      <b-row>
        <b-col md="3">
            <label class="labels">transaction number *</label>
          <div >
            <b-form-input v-model="model.cashNumber" placeholder="no transaction"></b-form-input>
          </div>
        </b-col>
        <b-col md="1"></b-col>
        <b-col md="3">
          <div class="form-group" v-bind:class="errors.has('journalAccountDebit') ? 'has-error':''" >
            <label class="labels">entered to</label>
            <b-form-select class="form-control" v-bind:class="errors.has('journalAccountDebit') ? 'is-invalid':''" data-vv-as="journalAccountDebit" name="journalAccountDebit" :options="isBankAccount" v-model="model.journalAccountDebit" /> 
            <p v-if="errors.has('journalAccountDebit') !== null"></p>
          </div>
        </b-col>
        <b-col md="3">
            <label>Account Balance</label>
            <money class="text-right text-bold text-danger text-2xl form-control" v-model="model.journalAccountBalanceNow" readonly placeholder="Debit"/>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="3">
        <div>
          <label class="labels">date*</label>
          <div class="form-group" v-bind:class="errors.has('cashDate') ? 'has-error':''">
          <b-form-datepicker type="date" class="form-control" v-bind:class="errors.has('cashDate') ? 'is-invalid':''" data-vv-as="cashDate"  name="cashDate" v-model="model.cashDate" v-validate="'required'" />
            <p v-if="errors.has('cashDate') !== null"></p>
          </div>
        </div>
        </b-col>
        <b-col md="1"></b-col>
        <b-col md="2">
          <label class="labels">Debit</label>
           <div class="form-group" v-bind:class="errors.has('idStaff') ? 'has-error':''">
              <money v-bind="money" class="text-right form-control"  
              v-bind:class="errors.has('cashTransactionDebit') ? 'is-invalid':''" data-vv-as="cashTransactionDebit" name="cashTransactionDebit"
               v-model="model.cashTransactionDebit"  placeholder="Debit"/>
            <p v-if="errors.has('cashTransactionDebit') !== null"></p>
          </div>
        </b-col>
        <b-col md="1"></b-col>
        <b-col md="4">
          <label for="" class="labels">Description</label>
          <b-form-input v-model="model.cashNote" placeholder="Description"/>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col md="3"></b-col>
        <b-col md="1"></b-col>
      </b-row>
      <b-row class="mt-5 mb-3">
        <b-col md="12" lg="12">
          <label for="" class="labels">from funds</label>
          <div class="table table-responsive mt-3 px-3 py-3" style="border: 1px dashed #c4c4c4; border-radius: 8px;">
            <table>
              <thead>
                <tr>
                  <th>No</th>
                  <th width="300" class="text-center">Account Name</th>
                  <th width="500" class="text-center">Details</th>
                  <th width="250" class="text-center">Total </th> 
                  <th class="text-center"></th> 
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in cashDataObject" :key="i" style="border: none;">
                  <td style="border: none;" v-text="i + 1"></td>
                  <td style="border: none;">
                    <v-select
                      id="mySelect"
                      label="text"
                      v-model="item.journalAccount"
                      :options="dataAccountName"
                      :reduce="(text) => text.value"
                      class="style-chooser"
                      style="border: none !important; border-left: none; border-right: none;"
                      placeholder="select journal account"
                    >
                      <template #search="{attributes, events}">
                        <input
                          class="vs__search"
                          :required="!item.journalAccount"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                  </td>
                  <td style="border: none;">
                    <b-form-input v-model="item.details" class="selected" />
                  </td>
                  <td style="border: none;" width="250">
                    <money v-bind="money" v-model="item.totalCashCredit" class="selected form-control text-right" />
                  </td>
                  <td style="border: none; margin-top : -35px !important;">
                    <i class="fas fa-trash-alt text-danger pointer" @click="deleteRow(i)"></i>
                  </td>
                </tr> 
                <tr style="border: none;">
                  <td style="border: none;"></td>
                  <td style="border: none;">
                  <b-link @click="addDataCash()">ADD</b-link>
                  </td>
                </tr>
                <tr style="border: none;">
                  <td style="border: none;"></td>
                  <td style="border: none;"></td>
                  <td style="border: none;"></td>
                  <!-- <td style="border: none;"></td> -->
                  <td style="border: none;" class="align-items-center">
                  <label class="labels mt-5">Total Cash</label>
                  <money class="font-weight-bold form-control text-right" readonly :value="sumCashIn()"></money>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-5 mb-4 pb-2">
              <b-col md="6">
                <b-button variant="secondary" class="btn-back float-left" @click="goBack()"
                  ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
                >
              </b-col>
              <b-col md="6">
                <div v-if="loadingButton" class="float-right">
                  <b-button variant="warning" disabled>
                    <b-spinner small type="grow"></b-spinner>
                    Loading...
                  </b-button>
                </div>
                <div v-else>
                  <b-button
                  :disabled="!disable"
                    variant="primary"
                    class="btn-back float-right"
                    type="submit"
                    ><font-awesome-icon icon="save"></font-awesome-icon>
                    Save
                  </b-button>
                </div>
              </b-col>
            </b-row>
      </form>
    </b-card>
  </div>
</template>
<script>
import {Money} from 'v-money'
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');

export default {
  components: { Money },
  data() {
    return {
      loadingButton: false,
      i: 1,
      accountName: '',
      token: this.$store.getters["account/tokens"].access_token,
      details: '',
      totalCash: 0,
      totalCashIn: 0,
      cashDataObject: [],
      isBankAccount: [],
      dataAccountName: [],
      model: {
        journalAccountDebit: null,
        cashTransactionDebit: 0,
        cashNumber: '',
        cashNote: '',
        cashDate: '',
        cashType: 'CI',
        cashTransaction: [],
        journalAccountBalanceNow: 0 
      },
      cashTransactionDebit: [],
      cashTransactionCredit: [],
      dataCreditCash: [],
      cashInData: [],

      apiUrl: {
        cashIn: window.AppConfig.apiUrl + 'cash',
        journal: window.AppConfig.apiUrl + 'journal-account',
      },

        //formatter curency
      money: {
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
    }
  },

   computed: {
    disable() {
      if (this.cashDataObject.length !== 0) {
        return true;
      }
      return false;
    },
  },

  watch: {
   'model.journalAccountDebit'(value){
     this.getBalanceAccount(value)
   }
  },

  mounted() {
    this.getJournalAccount()
    this.getJournal()
    this.initBalance()
  },

  methods: { 
    /** 
     * untuk menghitung total cash
     */
    sumCashIn(){
      let subtotal = 0
      this.cashDataObject.forEach(({ totalCashCredit }) => {
        subtotal = subtotal + ( totalCashCredit++ )
      });
      return subtotal;
    },

    /**
     * crud table untuk menambahkan row
     */
    addDataCash(){
      let r = this;
      r.cashDataObject.push({
        i: +1,
        journalAccount: null,
        details :'',
        totalCashDebit: 0,
        totalCashCredit:0
      })

    },

    /**
     * method POST untuk kirim data ke server
     * 
     */
    postCashIn(){
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loadingButton = true
          const cashDebit = this.model.cashTransactionDebit
          this.dataCreditCash.push({
            uuid:"",
            journalAccount: this.model.journalAccountDebit,
            cashTransactionNote: this.model.cashNote ,
            cashTransactionDebit: cashDebit,
            cashTransactionCredit:0,
            delete: 0  
    
          })
          const toCredit = this.cashDataObject.map((item) => ({
            uuid: '',
            journalAccount: item.journalAccount !==null ? item.journalAccount : '',
            cashTransactionDebit: 0,
            cashTransactionCredit: item.totalCashCredit,
            cashTransactionNote: item.details,
          }))
          let formData = new FormData()
          formData.append('cashNumber', this.model.cashNumber)
          formData.append('cashNote', this.model.cashNote)
          formData.append('cashType', this.model.cashType)
          formData.append('cashDate', this.model.cashDate)
          formData.append('cashTransactionDebit', JSON.stringify(this.dataCreditCash))
          formData.append('cashTransactionCredit', JSON.stringify(toCredit))
          this.$http.post(this.apiUrl.cashIn, formData).then((response) => {
          this.$store.dispatch("notification/success", "Cash In data has been Added")
          window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
            setTimeout(() => {
              this.loadingButton = false
            }, 1000)
          }).catch(error => {
              this.$store.dispatch("notification/error", error )
              setTimeout(() => {
                window.location.reload()
               this.loadingButton = false
              }, 1500)
              })
            
        }
      })
    },

     initBalance(){
      if(this.model.journalAccountDebit !== null){
        this.getBalanceAccount()
      }
    },

    getBalanceAccount(journalUuid) {
      this.$http.get(this.apiUrl.journal + '/' + journalUuid).then(resp =>{
        this.model.journalAccountBalanceNow = resp.data.journalAccountBalanceNow
      })
    },

    /**
     * Ambil journal akun dari server berdasarkan type bank
     */
    getJournalAccount(){
      this.$http.get(this.apiUrl.journal + '?journalAccountType=D&isBank=1')
      .then((response) => {
        this.isBankAccount = [ {
          value: null,
          text: 'Select Journal Account'
        }]
        response.data._embedded.journal_account.forEach( b => {
          this.isBankAccount.push({
            value: b.uuid,
            text: b.journalAccountName,
          })
        })
      })
      .catch(error => {console.log(error);})
    },

    /**
     * Ambil data dari journal dari server
     */
     getJournal(){
      this.$http.get(this.apiUrl.journal)
      .then((response) => {
        response.data._embedded.journal_account.forEach( b => {
          this.dataAccountName.push({
            value: b.uuid,
            text: b.journalAccountCode + ' ' + b.journalAccountName
          })
        })
      })
      .catch(error => {console.log(error);})
    },

    /**
     * hapus row dari table berdasarkan index
     */
    deleteRow(i){
      this.cashDataObject.splice(i, 1)
    },

  /**
   * formatter currency untuk data static
   */
   formatNumber(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  }
  
}
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  /* background: #dfe5fb; */
  border: none;
  color: #394066;
}
</style>